const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1428.19 177.82v-13.5c0-.62.51-1.125 1.13-1.125h11.25c.62 0 1.12.505 1.12 1.125v6.614l1.13-1.125v-5.489c0-1.242-1.01-2.25-2.25-2.25h-11.25a2.252 2.252 0 0 0-2.25 2.25v13.5c0 1.243 1.01 2.25 2.25 2.25h6.19v-1.125h-6.19a1.13 1.13 0 0 1-1.13-1.125Zm11.25-12.375h-9v1.125h9v-1.125Zm0 2.25h-9v1.125h9v-1.125Zm0 2.25h-9v1.125h9v-1.125Zm-9 3.375h4.5v-1.125h-4.5v1.125Zm14.3-1.125-.8-.795c-.21-.22-.5-.33-.79-.33-.29 0-.58.11-.8.33l-4.82 4.829c-.22.22-.9 1.07-.9 1.358l-.56 2.483 2.48-.562s1.14-.673 1.36-.892l4.83-4.83c.44-.439.44-1.152 0-1.591Zm-5.23 6.022c-.06.06-.28.209-.55.381l-1.46-1.458c.15-.205.32-.411.42-.513l3.64-3.636 1.59 1.591-3.64 3.635Z",
    style: {
      fill: "#727272",
      fillRule: "nonzero"
    },
    transform: "translate(-1424.07 -159.07)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.2be157517e5ccc04d2609849c2d1484c.svg";
export { ForwardRef as ReactComponent };